/* eslint-disable */
import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';

const KpiCard = ({
  icon: Icon, iconBg, iconColor, badge,
  title, mainAmount, mainSub,
  row1Label, row1Value,
  row2Label, row2Value, textColor,
  loading,
}) => (
  <Box
    sx={{
      backgroundColor: '#fff',
      border: '1px solid #D1D5DC',
      borderRadius: '12px',
      boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.06)',
      pt: '12px',
      pb: '16px',
      px: '16px',
      flex: 1,
      width: '300px',
    }}
  >
    {/* Icon + title */}
    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', minHeight: '100px' }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: '50%',
            backgroundColor: iconBg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          {typeof Icon === 'string'
            ? <img src={Icon} alt="" style={{ width: 22, height: 22 }} />
            : <Icon sx={{ fontSize: 22, color: iconColor }} />
          }
        </Box>
        <Box>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: textColor, lineHeight: 1.3, mb: '4px' }}>
            {title}
          </Typography>
          <Typography sx={{ fontSize: '18px', fontWeight: 700, color: '#000000', lineHeight: 1.2 }}>
            {loading
              ? <Skeleton variant="text" width={130} sx={{ display: 'inline-block' }} />
              : mainAmount}
          </Typography>
          {mainSub && mainSub}
        </Box>
      </Box>
    </Box>

    {/* Divider */}
    <Box sx={{ borderTop: '1.5px solid #E2E8F0', mt: '-32px', mb: '12px' }} />

    {/* Rows */}
    <Box sx={{ backgroundColor: '#F8FAFC', border: '1px solid #F1F5F9', borderRadius: '6px', px: '8px', py: '6px', mb: '6px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#717182' }}>
        {loading ? <Skeleton variant="text" width={100} /> : row1Label}
      </Typography>
      <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#717182' }}>
        {loading ? <Skeleton variant="text" width={80} /> : row1Value}
      </Typography>
    </Box>
    <Box sx={{ backgroundColor: '#F8FAFC', border: '1px solid #F1F5F9', borderRadius: '6px', px: '8px', py: '6px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#717182' }}>
        {loading ? <Skeleton variant="text" width={90} /> : row2Label}
      </Typography>
      <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#717182' }}>
        {loading ? <Skeleton variant="text" width={80} /> : row2Value}
      </Typography>
    </Box>
  </Box>
);

export default KpiCard;
